import { Helmet } from "react-helmet-async";

const SITE = "https://www.monseraphinstudio.fr";

/**
 * SEO component using react-helmet-async.
 * Pass title, description, path; injects OG/Twitter + canonical + optional JSON-LD.
 */
export default function SEO({
    title,
    description,
    path = "/",
    image = `${SITE}/og-image.jpg`,
    noindex = false,
    structuredData = null,
    keywords,
}) {
    const url = `${SITE}${path}`;
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={url} />
            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
            )}
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="Studio Mon Séraphin" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
}
